var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_cn_flag)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 24,
    height: 24,
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDE00",
    points: "6,5 6.9,7.2 9.2,7.2 7.3,8.6 8.1,10.8 6,9.5 3.9,10.8 4.7,8.6 2.8,7.2 5.1,7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDE00",
    points: "10,3.5 10.4,4.5 11.5,4.5 10.6,5.1 11,6.2 10,5.6 9,6.2 9.4,5.1 8.5,4.5 9.6,4.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDE00",
    points: "11.5,6 11.9,7 13,7 12.1,7.6 12.5,8.7 11.5,8.1 10.5,8.7 10.9,7.6 10,7 11.1,7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDE00",
    points: "11,9 11.4,10 12.5,10 11.6,10.6 12,11.7 11,11.1 10,11.7 10.4,10.6 9.5,10 10.6,10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDE00",
    points: "9,11.5 9.4,12.5 10.5,12.5 9.6,13.1 10,14.2 9,13.6 8,14.2 8.4,13.1 7.5,12.5 8.6,12.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_cn_flag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.cc6cd3d0f1a1b000cb73f48c4b079236.svg";
export { ForwardRef as ReactComponent };